export default "__VITE_ASSET__Dgl_w8_d__"